import styled, { css } from 'styled-components'

export const Container = styled.div`
  ${({ theme }) => css`
    grid-area: z;
    margin-left: auto;
    .tooptip-custom {
      width: 100%;
      background: ${theme.colors.white} !important;
      opacity: 1 !important;
      text-align: left;
      max-width: 260px;
      box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.2);
      border-radius: ${theme.border.radius};
      font-family: ${theme.font.montserrat};
      font-size: ${theme.font.sizes.xxxsmall};
      font-weight: ${theme.font.normal};
    }
  `}
`

export const HasHelpButtons = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${theme.colors.black};
    color: ${theme.colors.white};
    font-size: ${theme.font.sizes.xxsmall};
    border-radius: 50%;
    height: 32px;
    width: 32px;
    cursor: pointer;
  `}
`
